import React, { useMemo } from "react";
import styled from "styled-components";
import Calendar from "../../organisms/Calendar";
import { Card } from "react-bootstrap";
import CardTitle from "../../organisms/CardTitle";
import {
  VentasDelMes,
  VentasPorAno,
  VentasPorMes,
} from "../../../services/ventasServicios";

function CalendarSection({
  onVentaMesSeleccionado,
  ventasPorAno,
}: {
  ventasPorAno: VentasPorAno;
  onVentaMesSeleccionado: (ventaMes: VentasDelMes, fechaMes: Date) => void;
}) {
  const fechasHabilitadas = useMemo(() => {
    if (!ventasPorAno) return [] as Date[];

    const fechasHabilitadas: Date[] = [];

    Object.keys(ventasPorAno).forEach((anoStr) => {
      const ano = parseInt(anoStr);
      const ventasDeAno: VentasPorMes = ventasPorAno[ano];

      Object.keys(ventasDeAno).forEach((mesStr) => {
        const mes = parseInt(mesStr);
        let fecha = new Date();
        fecha.setDate(1);
        fecha.setFullYear(ano);
        fecha.setMonth(mes - 1);
        fechasHabilitadas.push(fecha);
      });
    });

    return fechasHabilitadas;
  }, [ventasPorAno]);

  const onMesClick = (date: Date) => {
    const mes = date.getMonth() + 1;
    const ano = date.getFullYear();
    const ventasPorMes = ventasPorAno?.[ano]?.[mes];
    if (ventasPorMes) {
      onVentaMesSeleccionado(ventasPorMes, date);
    }
  };

  return (
    <StyledCard>
      <StyledCardHeader className="mt-2">
        <CardTitle>{"Calendario de ventas"}</CardTitle>
      </StyledCardHeader>
      <StyledCardBody>
        <StyledCalendar
          maxDetail="year"
          selectRange={false}
          onDateClick={onMesClick}
          disableSelection={true}
          enabledDates={fechasHabilitadas}
        />
      </StyledCardBody>
    </StyledCard>
  );
}

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: start;
  align-items: center;
  border: 0px;
`;

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCalendar = styled(Calendar)`
  width: 100%;
  border-radius: 5px;
  padding: 0%;
`;

export default CalendarSection;
